import * as React from "react";
import { Link } from "react-router-dom";

import { RiArrowLeftLine } from "react-icons/ri";

import img404 from "../../Images/attijari404.png";

import "./Error404.scss";

const Error404 = () => {
  return (
    <div className="content_404">
      <div className="container">
        <div className="txt_zn">
          <div className="img-404">
            <img alt="404" src={img404} />
          </div>

          <p className="txt-404">
            Nous ne pouvons pas pu atteindre la page que vous recherchez !
          </p>

          <div className="text-center">
            <Link to="/" className="link-404">
              <RiArrowLeftLine /> Retour
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;
